import { createModuleStore } from '../utils'

export const usePrintersStore = createModuleStore(
  'printers',
  {
    type: 'RFID Printer',
    pageHeading: 'RFID Printers',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    uri: '/printers',
    serviceUri: '/printers',
    listingModuleName: 'Config',
    listingActivityName: 'View Printer',
    formModuleName: 'Config',
    formActivityName: 'Edit Printer',
    allFields: [
      {
        key: 'alias',
        title: 'ALIAS',
        visible: true,
        disabled: true,
        sortable: true,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'networkAddress',
        title: 'NETWORK ADDRESS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'macAddress',
        title: 'MAC ADDRESS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'labelFormat',
        title: 'LABEL FORMAT',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
    apiColumnsMapping: {
      alias: ['name'],
      macAddress: ['mac', 'mac address'],
      networkAddress: ['ip', 'network address', 'ip address'],
      labelFormat: ['label', 'label format', 'zpl'],
      status: ['status', 'row status', 'printer status'],
    },
  },
  {},
  {
    resetPageFilters() {
      const store = usePrintersStore()
      store.resetBaseFilters()
    },
    copy(item) {
      const obj = {
        alias: item.alias,
        networkAddress: item.networkAddress,
        macAddress: item.macAddress,
        labelFormat: item.labelFormat,
      }
      return obj
    },
  },
  {
    fields: [
      {
        id: 'printer_alias',
        name: 'alias',
        label: 'Alias',
        size: 8,
        component: 'NInput',
        componentProps: { placeholder: 'Enter descriptive printer alias' },
        rules: [
          {
            required: true,
            max: 100,
            trigger: ['blur', 'input'],
          },
          {
            remoteValidator: 'isPrinterAliasUnique',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'printer_network_address',
        name: 'networkAddress',
        label: 'Network Address',
        size: 8,
        component: 'NInput',
        componentProps: { placeholder: 'Enter printer network address' },
        rules: [
          {
            required: true,
            max: 100,
            trigger: ['blur', 'input'],
          },
          {
            remoteValidator: 'isPrinterNetworkAddressUnique',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'printer_macAddress',
        name: 'macAddress',
        label: 'MAC Address',
        size: 8,
        component: 'NInput',
        componentProps: { placeholder: 'Enter printer MAC address' },
        rules: [
          {
            required: true,
            max: 20,
            trigger: ['blur', 'input'],
          },
          {
            remoteValidator: 'isPrinterMacAddressUnique',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'printer_label_format',
        name: 'labelFormat',
        label: 'Label Format',
        size: 24,
        component: 'NInput',
        componentProps: { placeholder: 'Enter printer label format ZPL' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
